module.exports = __webpack_public_path__ + "assets/img/increaseTool.38ee28e9.png";